import * as yup from 'yup';

import translations from '../languages/i18n';

// ATENCIÓ: el nom de les propietats han d'estar en majúscula. És com estan al servidor
// TODO: aquest validationSchem s'hauria de construir dinàmicament a partir de les variables del formulari a mostrar

// ATENCIÓ: ORDENAR-LES ALFABETICAMENT

// Variables compartides per més d'un Standard Set
export const AGE = yup.string();
//	.required(translations['_fieldRequired']);

/* *********************************************************************** */
/* ********************* Variables LPC Standard Set ********************** */
/* *********************************************************************** */

export const BIOCHEM = yup.string();
//	.required(translations['_fieldRequired']);

export const BIOCHEMDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const BIOCHEMPSA = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const BIOPCORE = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const BIOPINVOL = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const BIOPPOS = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const COMORB = yup.array();
//	.required(translations['_fieldRequired']);

export const COMPLRAD = yup.string();
//	.required(translations['_fieldRequired']);

export const COMPLRADDOMGRA = yup.array();
//	.required(translations['_fieldRequired']);

export const COMPLRADDOMOTHER = yup.string();
//	.required(translations['_fieldRequired']);

export const COMPLSURG = yup.string();
//	.required(translations['_fieldRequired']);

export const DEATH = yup.string();
//	.required(translations['_fieldRequired']);

export const DEATHDATE = yup.string();
//	.required(translations['_fieldRequired']);

//	.required(translations['_fieldRequired']);
export const DEATHLPC = yup.string();

export const DIAGDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q01 = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q02 = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q03 = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q04a = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q04b = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q04c = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q04d = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q04e = yup.string();
//	.required(translations['_fieldRequired']);

//	.required(translations['_fieldRequired']);
export const EPIC26_Q05 = yup.string();

export const EPIC26_Q06a = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q06b = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q06c = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q06d = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q06e = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q07 = yup.string();
//	.required(translations['_fieldRequired']);

//	.required(translations['_fieldRequired']);
export const EPIC26_Q08a = yup.string();

export const EPIC26_Q08b = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q09 = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q10 = yup.string();
//	.required(translations['_fieldRequired']);

//	.required(translations['_fieldRequired']);
export const EPIC26_Q11 = yup.string();

export const EPIC26_Q12 = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q13a = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q13b = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q13c = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q13d = yup.string();
//	.required(translations['_fieldRequired']);

export const EPIC26_Q13e = yup.string();
//	.required(translations['_fieldRequired']);

export const GLEASONBIOP1 = yup.number()
	.typeError(translations['_mustBeNumber'])
	.integer(translations['_mustBeInteger'])
	.min(1, translations['_minimum1'])
	.max(5, translations['_maximum5']);
//	.required(translations['_fieldRequired']);

export const GLEASONBIOP2 = yup.number()
	.typeError(translations['_mustBeNumber'])
	.integer(translations['_mustBeInteger'])
	.min(1, translations['_minimum1'])
	.max(5, translations['_maximum5']);
//	.required(translations['_fieldRequired']);

export const GLEASONPATH1 = yup.number()
	.typeError(translations['_mustBeNumber'])
	.integer(translations['_mustBeInteger'])
	.min(1, translations['_minimum1'])
	.max(5, translations['_maximum5']);
//	.required(translations['_fieldRequired']);

export const GLEASONPATH2 = yup.number()
	.typeError(translations['_mustBeNumber'])
	.integer(translations['_mustBeInteger'])
	.min(1, translations['_minimum1'])
	.max(5, translations['_maximum5']);
//	.required(translations['_fieldRequired']);

export const LIBID_Q01 = yup.string();
//	.required(translations['_fieldRequired']);

export const LIBID_Q02 = yup.string();
//	.required(translations['_fieldRequired']);

export const LIBID_Q03a = yup.string();
//	.required(translations['_fieldRequired']);

export const LIBID_Q03b = yup.string();
//	.required(translations['_fieldRequired']);

export const LIBID_Q03c = yup.string();
//	.required(translations['_fieldRequired']);

export const LIBID_Q03d = yup.string();
//	.required(translations['_fieldRequired']);

export const LIBID_Q03e = yup.string();
//	.required(translations['_fieldRequired']);

export const MARGIN = yup.string();
//	.required(translations['_fieldRequired']);

export const MARGINFOC = yup.string();
//	.required(translations['_fieldRequired']);

export const METADATE = yup.string();
//	.required(translations['_fieldRequired']);

export const METADEV = yup.string();
//	.required(translations['_fieldRequired']);

export const PRACTIVEDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRADTTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const PRADTTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRADTTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRBRACHYDOSERATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRBRACHYTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const PRBRACHYTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRBRACHYTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PREBRTDOSEPERFRACT = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const PREBRTTOTDOSE = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const PREBRTTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const PREBRTTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PREBRTTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRFOCTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const PRFOCTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRFOCTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRIMARYTX = yup.array();
//	.required(translations['_fieldRequired']);

export const PRIMARYTXFT = yup.string();
//	.required(translations['_fieldRequired']);

export const PRIMARYTXOTHER = yup.string();
//	.required(translations['_fieldRequired']);

export const PRNERVESPARE = yup.string();
//	.required(translations['_fieldRequired']);

export const PROTHERTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const PROTHERTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PROTHERTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRRADPROTXDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PRWATCHDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const PSA = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const SALVAGETX = yup.array();
//	.required(translations['_fieldRequired']);

export const SALVAGETXINI = yup.string();
//	.required(translations['_fieldRequired']);

export const SALVAGETXOTHER = yup.string();
//	.required(translations['_fieldRequired']);

export const SVADTTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const SVADTTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVADTTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVBRACHYDOSERATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVBRACHYTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const SVBRACHYTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVBRACHYTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVEBRTDOSEPERFRACT = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const SVEBRTTOTDOSE = yup.number()
	.typeError(translations['_mustBeNumber']);
//	.required(translations['_fieldRequired']);

export const SVEBRTTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const SVEBRTTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVEBRTTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVFOCTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const SVFOCTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVFOCTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVNERVESPARE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVOTHERTXONGOING = yup.string();
//	.required(translations['_fieldRequired']);

export const SVOTHERTXSTARTDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVOTHERTXSTOPDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const SVRADPROTXDATE = yup.string();
//	.required(translations['_fieldRequired']);

export const TNMCN = yup.string();
//	.required(translations['_fieldRequired']);

export const TNMCT = yup.string();
//	.required(translations['_fieldRequired']);

export const TNMPN = yup.string();
//	.required(translations['_fieldRequired']);

export const TNMPT = yup.string();
//	.required(translations['_fieldRequired']);

/* *********************************************************************** */
/* *************** Variables CAT (Cataractes) Standard Set *************** */
/* *********************************************************************** */

export const AMBLY = yup.string();
//	.required(translations['_fieldRequired']);

export const AXISLT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const AXISLT_TAR = yup.string();
//	.required(translations['_fieldRequired']);

export const AXISRT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const AXISRT_TAR = yup.string();
//	.required(translations['_fieldRequired']);

export const BWCAT = yup.string();
//	.required(translations['_fieldRequired']);

export const CAPSULEINT = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q01 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q02 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q03 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q04 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q05 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q06 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q07 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q08 = yup.string();
//	.required(translations['_fieldRequired']);

export const CATQUEST9SF_Q09 = yup.string();
//	.required(translations['_fieldRequired']);

export const COREDE = yup.string();
//	.required(translations['_fieldRequired']);

export const COROPA = yup.string();
//	.required(translations['_fieldRequired']);

export const CYLLT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const CYLLT_TAR = yup.string();
//	.required(translations['_fieldRequired']);

export const CYLRT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const CYLRT_TAR = yup.string();
//	.required(translations['_fieldRequired']);

export const DIABEYE = yup.string();
//	.required(translations['_fieldRequired']);

export const ENDO = yup.string();
//	.required(translations['_fieldRequired']);

export const GLAU = yup.string();
//	.required(translations['_fieldRequired']);

export const LENSVIT = yup.string();
//	.required(translations['_fieldRequired']);

export const MACDEGEN = yup.string();
//	.required(translations['_fieldRequired']);

export const OTHER = yup.string();
//	.required(translations['_fieldRequired']);

export const OTHEROPINT = yup.string();
//	.required(translations['_fieldRequired']);

export const OTHER_INTRA = yup.string();
//	.required(translations['_fieldRequired']);

export const PREVCATSURG = yup.string();
//	.required(translations['_fieldRequired']);

export const PREVCORSURG = yup.string();
//	.required(translations['_fieldRequired']);

export const PREVVIT = yup.string();
//	.required(translations['_fieldRequired']);

export const PSEUDOEX = yup.string();
//	.required(translations['_fieldRequired']);

export const PUPIL = yup.string();
//	.required(translations['_fieldRequired']);

export const REOP = yup.string();
//	.required(translations['_fieldRequired']);

export const SEX = yup.string();
//	.required(translations['_fieldRequired']);

export const SPHERELT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const SPHERELT_TAR = yup.string();
//	.required(translations['_fieldRequired']);

export const SPHERERT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const SPHERERT_TAR = yup.string();
//	.required(translations['_fieldRequired']);

export const SURGTEC = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUCORLT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUCORLT_PRE = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUCORRT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUCORRT_PRE = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUUNCLT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUUNCLT_PRE = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUUNCRT_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUUNCRT_PRE = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUUNI_POST = yup.string();
//	.required(translations['_fieldRequired']);

export const VISACUUNI_PRE = yup.string();
//	.required(translations['_fieldRequired']);

export const VITPRO = yup.string();
//	.required(translations['_fieldRequired']);

export const ZONULESINT = yup.string();
//	.required(translations['_fieldRequired']);
